import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  overallStatus206eg9g5yqouc as overallStatus,
  PayAppStatus_Draft_getInstance171ihe7xpmy9q as PayAppStatus_Draft_getInstance,
} from './data.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../theming/sections.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { DisplayableStateSemantic2q119ycceacla as DisplayableStateSemantic } from '../../../../theming/states.mjs';
import { dynamicThemexp3sdnaolntz as dynamicTheme } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { tableEntryUnderlinedMoney1xb094tujwxjo as tableEntryUnderlinedMoney } from '../../../keyValue.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  ApprovedSemantic_getInstance10vizqzbc90jx as ApprovedSemantic_getInstance,
  DeniedSemantic_getInstanceb7su0ait1it4 as DeniedSemantic_getInstance,
} from '../../../../theming/approval.mjs';
import { EmphasizedSemantic_getInstancev1hnk3pae9tz as EmphasizedSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../theming/colorManagement.mjs';
import { PayAppDetails12i3yidr5kt7h as PayAppDetails } from './PayAppDetails.mjs';
import { PayAppForm28kp0pq290pd9 as PayAppForm } from './PayAppForm.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderPayAppCard(_this__u8e3s4, payApp, items, writer) {
  // Inline function 'kotlin.with' call
  var status = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = $this$remember.baj(items);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp0_safe_receiver = element.shc_1;
      var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_status(tmp0_safe_receiver);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.v(tmp0_safe_receiver_0);
      }
    }
    return overallStatus(toSet(destination));
  });
  var tmp = get_lightSection(writer);
  // Inline function 'com.lightningkite.kiteui.views.direct.link' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Link())(writer.pc());
  var tmp0_elvis_lhs = writer.cbb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  var tmp_0 = view_1.ibb(get_centered(view_1), get_expanding(view_1));
  // Inline function 'com.crowpay.views.theming.boldSubTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$7 = 'Draw ' + $this$reactiveScope.baj(payApp).k6y_1;
    this_0.set(tmp$ret$7);
    return Unit_instance;
  });
  view_1.fbb(p_2, view_2);
  view_1.jbb(tmp_0, view_2);
  var tmp_3 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  dynamicTheme(view_3, ($this$dynamicTheme) => DisplayableStateSemantic().mgt($this$dynamicTheme.baj(status)));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_0(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_0(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp$ret$14 = $this$reactiveScope.baj(status).vhf_1;
    this_1.set(tmp$ret$14);
    return Unit_instance;
  });
  view_1.fbb(p_3, view_3);
  view_1.jbb(tmp_3, view_3);
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_4 = view_0.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
  view_0.ebb(p_4, view_4);
  view_4.xbm(false);
  var tmp_6 = get_expanding(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.xbm(true);
  tableEntryUnderlinedMoney(view_5, 'Work Value', ($this$tableEntryUnderlinedMoney) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$tableEntryUnderlinedMoney.baj(items);
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp0_safe_receiver = element.shc_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6v_1;
      var tmp_0;
      var tmp_1 = tmp1_elvis_lhs;
      if ((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null) {
        tmp_0 = Companion_instance.p91(0n);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var tmp$ret$25 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$25);
    }
    var tmp$ret$26 = sum;
    return new (MonetaryValue())(tmp$ret$26);
  });
  // Inline function 'com.crowpay.views.components.tableEntryUnderlined' call
  var key = 'Approved';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  view_6.xbm(true);
  view_6.zb8(get_dp(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.ebb(p_7, view_7);
  view_7.xbm(false);
  view_7.zb8(get_rem(0.5));
  view_7.jbb(get_expanding(view_7), body(view_7, key));
  var tmp_7 = view_7.hbb(ApprovedSemantic_getInstance().ybe(EmphasizedSemantic_getInstance()));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.cbb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.ebb(p_8, view_8);
  view_8.jba(view_8.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl_1(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb_1(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.baj(items);
    var tmp$ret$27 = MonetaryValue__toString_impl_xslc77(renderPayAppCard$_anonymous_$_anonymous_$_anonymous_$sumDraws_6y6uvm(tmp, renderPayAppCard$lambda$lambda));
    this_2.set(tmp$ret$27);
    return Unit_instance;
  });
  view_7.fbb(p_8, view_8);
  view_7.jbb(tmp_7, view_8);
  view_6.fbb(p_7, view_7);
  greySeparator(view_6);
  view_5.fbb(p_6, view_6);
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_6, view_5);
  var tmp_10 = get_expanding(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_9 = view_4.cbb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_4 : tmp0_elvis_lhs_9;
  view_4.ebb(p_9, view_9);
  view_9.xbm(true);
  // Inline function 'com.crowpay.views.components.tableEntryUnderlined' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_10 = view_9.cbb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.ebb(p_10, view_10);
  view_10.xbm(true);
  view_10.zb8(get_dp(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.cbb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.ebb(p_11, view_11);
  view_11.xbm(false);
  view_11.zb8(get_rem(0.5));
  view_11.jbb(get_expanding(view_11), body(view_11, 'Pending'));
  var tmp_11 = colored(view_11, AppColors_getInstance().ffz_1.wg9_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_12 = new (TextView())(view_11.pc());
  var tmp0_elvis_lhs_12 = view_11.cbb_1;
  var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
  view_11.ebb(p_12, view_12);
  view_12.jba(view_12.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_12 = KMutableProperty0();
  var tmp_13 = TextView$_get_content_$ref_4pzcwl_2(view_12);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_2(view_12));
  reactiveScope(view_12, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.baj(items);
    var tmp$ret$48 = MonetaryValue__toString_impl_xslc77(renderPayAppCard$_anonymous_$_anonymous_$_anonymous_$sumDraws_6y6uvm(tmp, renderPayAppCard$lambda$lambda_0));
    this_3.set(tmp$ret$48);
    return Unit_instance;
  });
  view_11.fbb(p_12, view_12);
  view_11.jbb(tmp_11, view_12);
  view_10.fbb(p_11, view_11);
  greySeparator(view_10);
  view_9.fbb(p_10, view_10);
  // Inline function 'com.crowpay.views.components.tableEntryUnderlined' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_13 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_13 = view_9.cbb_1;
  var p_13 = tmp0_elvis_lhs_13 == null ? view_9 : tmp0_elvis_lhs_13;
  view_9.ebb(p_13, view_13);
  view_13.xbm(true);
  view_13.zb8(get_dp(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_14 = new (RowOrCol())(view_13.pc());
  var tmp0_elvis_lhs_14 = view_13.cbb_1;
  var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
  view_13.ebb(p_14, view_14);
  view_14.xbm(false);
  view_14.zb8(get_rem(0.5));
  view_14.jbb(get_expanding(view_14), body(view_14, 'Waited'));
  var tmp_14 = view_14.hbb(DeniedSemantic_getInstance().ybe(EmphasizedSemantic_getInstance()));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_15 = new (TextView())(view_14.pc());
  var tmp0_elvis_lhs_15 = view_14.cbb_1;
  var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
  view_14.ebb(p_15, view_15);
  view_15.jba(view_15.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_15 = KMutableProperty0();
  var tmp_16 = TextView$_get_content_$ref_4pzcwl_3(view_15);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_15, tmp_16, TextView$_set_content_$ref_pketfb_3(view_15));
  reactiveScope(view_15, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.baj(items);
    var tmp$ret$65 = MonetaryValue__toString_impl_xslc77(renderPayAppCard$_anonymous_$_anonymous_$_anonymous_$sumDraws_6y6uvm(tmp, renderPayAppCard$lambda$lambda_1));
    this_4.set(tmp$ret$65);
    return Unit_instance;
  });
  view_14.fbb(p_15, view_15);
  view_14.jbb(tmp_14, view_15);
  view_13.fbb(p_14, view_14);
  greySeparator(view_13);
  view_9.fbb(p_13, view_13);
  view_4.fbb(p_9, view_9);
  view_4.jbb(tmp_10, view_9);
  view_0.fbb(p_4, view_4);
  view.fbb(p_0, view_0);
  var tmp_17 = KMutableProperty0();
  var tmp_18 = Link$_get_to_$ref_jq7esp(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_5 = getPropertyCallableRef('to', 0, tmp_17, tmp_18, Link$_set_to_$ref_i9gu5x(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var $this$invoke = $this$reactiveScope;
    var tmp;
    if ($this$invoke.baj(status).equals(PayAppStatus_Draft_getInstance())) {
      tmp = () => new (PayAppForm())($this$invoke.baj(payApp).i6y_1);
    } else {
      tmp = () => new (PayAppDetails())(_this__u8e3s4.jf8(), $this$invoke.baj(payApp).i6y_1, _this__u8e3s4.rgj());
    }
    var tmp$ret$94 = tmp;
    this_5.set(tmp$ret$94);
    return Unit_instance;
  });
  writer.fbb(p, view);
  return writer.jbb(tmp, view);
}
function renderPayAppCard$_anonymous_$_anonymous_$_anonymous_$sumDraws_6y6uvm(_this__u8e3s4, predicate) {
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.p91(0n);
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp = sum;
    var tmp0_safe_receiver = element.shc_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      tmp_0 = predicate(tmp0_safe_receiver) ? tmp0_safe_receiver : null;
    }
    var tmp1_safe_receiver = tmp_0;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t6v_1;
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
      tmp_1 = Companion_instance.p91(0n);
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var tmp$ret$1 = tmp_1;
    sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$1);
  }
  return sum;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderPayAppCard$lambda$lambda(it) {
  return !(it.u6v_1 == null);
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderPayAppCard$lambda$lambda_0(it) {
  return it.b6w_1;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function renderPayAppCard$lambda$lambda_1(it) {
  return !(it.v6v_1 == null);
}
function Link$_get_to_$ref_jq7esp(p0) {
  return () => p0.xbv_1;
}
function Link$_set_to_$ref_i9gu5x(p0) {
  return (_this__u8e3s4) => {
    p0.ibw(_this__u8e3s4);
    return Unit_instance;
  };
}
//region block: exports
export {
  renderPayAppCard as renderPayAppCard339rz4b2yqqq1,
};
//endregion

//# sourceMappingURL=cards.mjs.map
